module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-152x152-34ba4d895d27d2d4103838fbba747174.png";